import React, { useContext, useEffect, useState } from "react";
import { InfoBarContext } from "../../common/info";
import { GET } from "../../utils/fetchUtil";
import { isTouch } from "../../utils/screenUtil";
import InputField from "../../common/input/InputField";
import InMaking from "./overview/InMaking";
import Submitted from "./overview/Submitted";
import Tabs from "../../common/tabs/Tabs";
import Tab from "../../common/tabs/Tab";
import { useTranslation } from "react-i18next";
import Solved from "./overview/Solved";
import { useDebounce } from "../../common/hooks/useDebounce";
import Loader from "../../common/loader/Loader";
import { useQuery } from "../../common/hooks/useQuery";
import { smoothScroll } from "../../utils/scrollbarUtil";
import { getElement } from "../../utils/scrollbarUtil";
import { useHistory } from "react-router-dom";
import { MessageContext } from "../../common/message";

function MyRequestsPage({ user }) {
  const [inMaking, setInMaking] = useState([]);
  const [submitted, setSubmitted] = useState([]);
  const [solved, setSolved] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [tabs, setTabs] = useState([]);
  const [request, setRequest] = useState(undefined);
  const [query, setQuery] = useState("");
  const debouncedQuery = useDebounce(query, 250);
  const [activeJournalId, setActiveJournalId] = useState(null);
  const { t } = useTranslation();
  const infoBar = useContext(InfoBarContext);
  const queryParams = useQuery();
  const history = useHistory();
  const message = useContext(MessageContext);
  const historyState = history.location.state;
  const linkTab = history.location.state?.tab;

  useEffect(() => {
    GET(
      "/requests/submissions?groupByStatus=true" +
        (debouncedQuery.length > 0 ? `&query=${debouncedQuery}` : ""),
      (requests) => {
        setRequest(requests);
      },
      (error) => {
        setRequest(error);
        message.toggle({
          title: t("requests.overview.supplement.infoBar.errorTitle"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, []);

  useEffect(() => {
    if (linkTab) {
      setActiveTab(linkTab);
    }
  }, [historyState]);

  useEffect(() => {
    request &&
      setInMaking(
        request.inMaking.filter((req) =>
          req.title.toString().toLowerCase().includes(query.toLowerCase())
        )
      );
    request &&
      setSubmitted(
        request.submitted.filter((req) =>
          req.title.toString().toLowerCase().includes(query.toLowerCase())
        )
      );
    request &&
      setSolved(
        request.solved.filter((req) =>
          req.title.toString().toLowerCase().includes(query.toLowerCase())
        )
      );
  }, [debouncedQuery, request]);

  useEffect(() => {
    if (!infoBar.isOpen) {
      setActiveJournalId(null);
    }
  }, [infoBar.isOpen, setActiveJournalId]);

  const scroller = (el, top, timeout) => {
    let scrollTimeout;
    const getContent = getElement(el);
    getContent.scrollBy({
      top: top,
      behavior: "smooth",
    });
    getContent.addEventListener("scroll", function () {
      scrollTimeout = setTimeout(function () {
        clearTimeout(scrollTimeout);
      }, timeout);
    });
  };

  useEffect(() => {
    if (historyState === "/requests/#t1" && request) {
      setTimeout(() => {
        setActiveTab(1);
      }, 0);

      scroller("#contentId", 520, 100000);
    }
  }, [historyState, request]);

  useEffect(() => {
    if (historyState === "/requests/#t0" && request) {
      setTimeout(() => {
        setActiveTab(0);
      }, 0);
    }
  }, [historyState, request]);

  useEffect(() => {
    smoothScroll("#solved" + queryParams.get("id"));
  }, [queryParams.get("id")]);

  useEffect(() => {
    setTabs([
      t("requests.overview.inMaking.tab", { count: inMaking.length }),
      t("requests.overview.submitted.tab", { count: submitted.length }),
      t("requests.overview.solved.tab", { count: solved.length }),
    ]);
  }, [inMaking, submitted, solved, t]);

  if (request) {
    return (
      <div className="mx-2 ">
        <div className="mt-2 is-flex is-flex-direction-row-reverse">
          <div className="field control" style={{ width: isTouch() ? "100%" : "25%" }}>
            <InputField
              placeholder={t("requests.overview.searchInputFieldPlaceholder")}
              onChange={(e) => setQuery(e.currentTarget.value)}
              value={query}
            />
          </div>
        </div>
        <Tabs
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          scrollableContentHeight={812}
          user={user}
        >
          <Tab
            label={tabs[0]}
            render={() => (
              <InMaking
                // sortiranje po uid buduci da submissionDate nije dostupan za zahtjeve u izradi
                requests={inMaking.sort((idA, idB) => (idA.uid > idB.uid ? 1 : -1)).reverse()}
                activeJournalId={activeJournalId}
                setActiveJournalId={setActiveJournalId}
                title={tabs[0]}
                setInMaking={setInMaking}
              />
            )}
          />
          <Tab
            label={tabs[1]}
            render={() => (
              <Submitted
                requests={submitted.sort(function (dateA, dateB) {
                  return new Date(dateB.submissionDate) - new Date(dateA.submissionDate);
                })}
                activeJournalId={activeJournalId}
                setActiveJournalId={setActiveJournalId}
                title={tabs[1]}
              />
            )}
          />
          <Tab
            label={tabs[2]}
            render={() => (
              <Solved
                requests={solved.sort(function (dateA, dateB) {
                  return new Date(dateB.submissionDate) - new Date(dateA.submissionDate);
                })}
                activeJournalId={activeJournalId}
                setActiveJournalId={setActiveJournalId}
                title={tabs[2]}
              />
            )}
          />
        </Tabs>
      </div>
    );
  } else {
    return <Loader size={`8x`} className="is-flex-grow-1 is-align-self-center" />;
  }
}

export default MyRequestsPage;
